var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-folder"
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title"
                        },
                        [_vm._v(_vm._s(_vm.currentTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isHomework
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-folder-info"
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$gettext(
                                    "Dieser Ordner ist ein Hausaufgabenordner. Es können nur Dateien eingestellt werden."
                                  )
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.isTeacher
                            ? _c("p", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$gettext(
                                        "Sie selbst haben folgende Dateien in diesen Ordner eingestellt"
                                      )
                                    ) +
                                    ":\n                "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "cw-block-folder-list"
                    },
                    [
                      _vm._l(_vm.files, function(file) {
                        return _c(
                          "li",
                          {
                            key: file.id,
                            staticClass: "cw-block-folder-file-item"
                          },
                          [
                            _vm.downloadEnabled
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      download: file.attributes.name,
                                      title: _vm.$gettext(
                                        "Datei herunterladen"
                                      ),
                                      href: file.meta["download-url"]
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "cw-block-file-info",
                                        class: [
                                          "cw-block-file-icon-" +
                                            _vm.getIcon(
                                              file.attributes["mime-type"]
                                            )
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(file.attributes.name) +
                                            "\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.isTeacher && _vm.isHomework
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "cw-block-file-details"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "cw-block-file-owner"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      file.relationships.owner
                                                        .meta.name
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "cw-block-file-mkdate"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.getFormattedDate(
                                                        file.attributes.mkdate
                                                      )
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cw-block-file-info download-disabled",
                                      class: [
                                        "cw-block-file-icon-" +
                                          _vm.getIcon(
                                            file.attributes["mime-type"]
                                          )
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(file.attributes.name) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cw-block-file-details"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "cw-block-file-mkdate"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.getFormattedDate(
                                                  file.attributes.mkdate
                                                )
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _vm.files.length === 0
                        ? _c("li", [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "cw-block-file-info cw-block-file-icon-empty"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$gettext("Dieser Ordner ist leer")
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.uploadEnabled
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-folder-upload"
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "default",
                              on: {
                                submit: function submit($event) {
                                  $event.preventDefault()
                                }
                              }
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$gettext(
                                        "Dateien zum Hochladen auswählen"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                                _c("input", {
                                  ref: "uploadFile",
                                  staticClass: "cw-file-input",
                                  attrs: {
                                    type: "file"
                                  },
                                  on: {
                                    change: _vm.displayTermSelector
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "button",
                                    on: {
                                      click: _vm.uploadFile
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext("Datei hochladen")
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showTermSelector
                            ? _c("studip-dialog", {
                                attrs: {
                                  width: "780",
                                  height: "510",
                                  title: _vm.$gettext("Lizenz auswählen"),
                                  confirmText: _vm.$gettext("Speichern"),
                                  confirmClass: "accept",
                                  closeText: _vm.$gettext(
                                    "Lizenzauswahl abbrechen"
                                  ),
                                  closeClass: "cancel"
                                },
                                on: {
                                  close: function close($event) {
                                    _vm.showTermSelector = false
                                  },
                                  confirm: _vm.selectTerm
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "dialogContent",
                                      fn: function fn() {
                                        return [
                                          _c(
                                            "form",
                                            {
                                              staticClass: "default",
                                              on: {
                                                submit: function submit(
                                                  $event
                                                ) {
                                                  $event.preventDefault()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "1ex"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$gettext(
                                                          "Bereitgestellte Dateien können heruntergeladen und ggf. weiterverbreitet werden. Dabei ist das Urheberrecht sowohl beim Hochladen der Datei als auch bei der Nutzung zu beachten. Bitte geben Sie daher an, um welche Art von Bereitstellung es sich handelt. Diese Angabe dient mehreren Zwecken: Beim Herunterladen wird ein Hinweis angezeigt, welche Nutzung der Datei zulässig ist. Beim Hochladen stellt die Angabe eine Entscheidungshilfe dar, damit Sie sichergehen können, dass die Datei tatsächlich bereitgestellt werden darf."
                                                        )
                                                      ) +
                                                      "\n                            "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "fieldset",
                                                {
                                                  staticClass:
                                                    "select_terms_of_use"
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.termsOfUse,
                                                    function(term) {
                                                      var _domProps

                                                      return [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.selectedTerm,
                                                              expression:
                                                                "selectedTerm"
                                                            }
                                                          ],
                                                          key:
                                                            term.id + "_input",
                                                          attrs: {
                                                            type: "radio",
                                                            name:
                                                              "content_terms_of_use_id",
                                                            id:
                                                              "content_terms_of_use-" +
                                                              term.id,
                                                            "aria-description":
                                                              term.description
                                                          },
                                                          domProps:
                                                            ((_domProps = {
                                                              value: term.id,
                                                              checked:
                                                                _vm.selectedTerm ===
                                                                term.id
                                                            }),
                                                            (_domProps[
                                                              "checked"
                                                            ] = _vm._q(
                                                              _vm.selectedTerm,
                                                              term.id
                                                            )),
                                                            _domProps),
                                                          on: {
                                                            change: function change(
                                                              $event
                                                            ) {
                                                              _vm.selectedTerm =
                                                                term.id
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "label",
                                                          {
                                                            key:
                                                              term.id + "label",
                                                            on: {
                                                              click: function click(
                                                                $event
                                                              ) {
                                                                _vm.selectedTerm =
                                                                  term.id
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "icon"
                                                              },
                                                              [
                                                                _c(
                                                                  "studip-icon",
                                                                  {
                                                                    attrs: {
                                                                      shape:
                                                                        term
                                                                          .attributes
                                                                          .icon,
                                                                      size: "32"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                            " +
                                                                    _vm._s(
                                                                      term
                                                                        .attributes
                                                                        .name
                                                                    ) +
                                                                    "\n                                        "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("studip-icon", {
                                                              staticClass:
                                                                "arrow",
                                                              attrs: {
                                                                shape:
                                                                  "arr_1down",
                                                                size: "24"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("studip-icon", {
                                                              staticClass:
                                                                "check",
                                                              attrs: {
                                                                shape:
                                                                  "check-circle",
                                                                size: "24"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            key:
                                                              term.id +
                                                              "_description",
                                                            staticClass:
                                                              "terms_of_use_description"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "description"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                            " +
                                                                    _vm._s(
                                                                      term
                                                                        .attributes
                                                                        .description
                                                                    ) +
                                                                    "\n                                        "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  492840561
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Überschrift")) +
                                "\n                    "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentTitle,
                                  expression: "currentTitle"
                                }
                              ],
                              attrs: {
                                type: "text"
                              },
                              domProps: {
                                value: _vm.currentTitle
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.currentTitle = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Ordner")) +
                                  "\n                    "
                              ),
                              _c("courseware-folder-chooser", {
                                attrs: {
                                  allowUserFolders: "",
                                  allowHomeworkFolders: ""
                                },
                                model: {
                                  value: _vm.currentFolderId,
                                  callback: function callback($$v) {
                                    _vm.currentFolderId = $$v
                                  },
                                  expression: "currentFolderId"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$gettext("Informationen zum Dateiordner-Block")
                      )
                    )
                  ])
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }